var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"float":"","fluid":""}},[_c('v-card',[_c('iframe',{attrs:{"src":"../../pdfs/kyd-privacy-policy.pdf","type":"application/pdf","width":"100%","height":"630px;"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }